import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Col,
  Row,
  Space,
  notification,
  Dropdown,
  Menu,
  Pagination,
  Tooltip,
  Radio,
  Spin,
  Tag,
} from 'antd';
import MobHeader from '../../Components/Header/MobHeader';
import {
  ThemeButton,
  ThemeDivider,
  ThemeFilterBtn,
  ThemeForm,
  ThemeInput,
  ThemeMainWrapper,
  ThemeModal,
  ThemeTableCard,
  ThemeTable,
  CardPaginationWrapper,
  XThemeSelect,
  ThemeRadio,
} from '../Styles/Theme';
import {
  ProjectTag,
  ProjectNameLink,
  ProjectTableActionWrapper,
  ThemeProjectCard,
  ThemeProjectTabWrapper,
  InsightEngineModalRadioGroup,
  ProjectListScrollable,
  ProjectSettingsCard,
} from './ProjectsStyle';
import { CardMenuIcon } from '../Campaigns/CampaignsStyle';
import {
  ProjectStatusTag,
  getProjectStatusConfig,
} from '../../Components/StatusTag';
import {
  RightOutlined,
  SearchOutlined,
  UsergroupAddOutlined,
  EllipsisOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatDate } from '../../utils/helpers';
import { GreetingText } from '../Dashboard/DashboardStyle';
import '../index.css';
import { useProjectPermissions } from '../../utils/permissions';
import {
  getProjectsApi,
  getProjectsReset,
  createProjectApi,
  createProjectReset,
  deleteProjectApi,
  deleteProjectReset,
  getEligibleCampaignsApi,
  getEligibleCampaignsReset,
  createProjectFromCampaignApi,
  createProjectFromCampaignReset,
  updateProjectApi,
  updateProjectReset,
} from '../../store/actions/projectAction';
import useFolders from "../../hooks/useFolders";
import {
  FolderBackNav,
  FolderCardsSection,
  ItemsSectionLabel,
  NewFolderButton,
  FolderModals,
  FolderSelector,
} from '../../Components/FolderComponents';

const Project = props => {
  // Permission check - shortcut hook
  const { can, isSuperAdmin } = useProjectPermissions();

  const {
    getProjects,
    getProjectsReset,
    getProjectsState,
    createProject,
    createProjectReset,
    createProjectState,
    deleteProject,
    deleteProjectReset,
    deleteProjectState,
    getEligibleCampaigns,
    getEligibleCampaignsReset,
    getEligibleCampaignsState,
    createProjectFromCampaign,
    createProjectFromCampaignReset,
    createProjectFromCampaignState,
    updateProject,
    updateProjectReset,
    updateProjectState,
  } = props;

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = ThemeForm.useForm();
  const [createProjectModal, setCreateProjectModal] = useState(false);
  const [createMode, setCreateMode] = useState('scratch'); // 'scratch' or 'campaign'
  const [projectBatchTag, setProjectBatchTag] = useState('');
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [eligibleCampaigns, setEligibleCampaigns] = useState([]);
  const [studySearchValue, setStudySearchValue] = useState('');
  const [createProjectDemographicFormat, setCreateProjectDemographicFormat] = useState(null);
  const [activeView, setActiveView] = useState('card');
  const [isMobile, setIsMobile] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [cardData, setCardData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  const [editForm] = ThemeForm.useForm();

  const defaultFilters = {
    page: 1,
    limit: 12,
    search: '',
    status: '',
    sortBy: 'createdAt',
    sortDirection: 'desc',
  };

  const getFiltersFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlFilters = {};
    for (const [key, value] of urlParams.entries()) {
      urlFilters[key] = value;
    }
    const filters = {
      ...defaultFilters,
      ...urlFilters,
    };
    return filters;
  };

  const initialFilters = getFiltersFromUrl();
  const [filters, setFilters] = useState(initialFilters);
  const [searchValue, setSearchValue] = useState(initialFilters.search || '');

  // Shared folder hook
  const folderHook = useFolders({ entityType: 'project', searchValue });
  const {
    folders,
    filteredFolders,
    currentFolderId,
    currentFolderName,
    refreshNeeded,
    createFolderModal,
    setCreateFolderModal,
    renameFolderModal,
    setRenameFolderModal,
    folderToRename,
    deleteFolderModal,
    setDeleteFolderModal,
    folderToDelete,
    moveToFolderModal,
    setMoveToFolderModal,
    selectedFolderId,
    setSelectedFolderId,
    createItemFolderId: createProjectFolderId,
    setCreateItemFolderId: setCreateProjectFolderId,
    removeFromFolderModal,
    setRemoveFromFolderModal,
    itemToRemove: projectToRemove,
    foldersCollapsed,
    setFoldersCollapsed,
    itemsCollapsed: projectsCollapsed,
    setItemsCollapsed: setProjectsCollapsed,
    draggedItem: draggedProject,
    dragOverFolderId,
    folderForm,
    renameFolderForm,
    createFolderState,
    renameFolderState,
    deleteFolderState,
    addItemToFolderState,
    removeItemFromFolderState,
    fetchFolders,
    getFoldersState,
    handleGetFoldersResponse,
    handleCreateFolderResponse,
    handleRenameFolderResponse,
    handleDeleteFolderResponse,
    handleAddItemToFolderResponse,
    handleRemoveItemFromFolderResponse,
    handleCreateFolder,
    handleRenameFolder,
    handleDeleteFolder,
    handleMoveToFolder,
    handleRemoveFromFolder,
    confirmRemoveFromFolder,
    handleFolderClick,
    handleBackToRoot,
    openRenameFolderModal,
    openDeleteFolderModal,
    openMoveToFolderModal,
    handleDragStart,
    handleDragEnd,
    handleFolderDragOver,
    handleFolderDragEnter,
    handleFolderDragLeave,
    handleFolderDrop,
    addItemToFolder,
  } = folderHook;

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  // Check for URL params to open create modal with campaign mode
  useEffect(() => {
    const createFrom = searchParams.get('createFrom');
    const campaignId = searchParams.get('campaignId');

    if (createFrom === 'campaign' && campaignId && can('create-from-study')) {
      setSelectedCampaignId(campaignId);
      setCreateMode('campaign');
      setCreateProjectModal(true);
      getEligibleCampaigns();
      // Clear the URL params
      setSearchParams({});
    }
  }, [searchParams]);

  // Handle eligible campaigns response
  useEffect(() => {
    if (
      getEligibleCampaignsState.apiState === 'success' &&
      getEligibleCampaignsState.data
    ) {
      const campaignsData =
        getEligibleCampaignsState.data.data || getEligibleCampaignsState.data;
      const campaigns = campaignsData.campaigns || [];
      setEligibleCampaigns(campaigns);
      getEligibleCampaignsReset();
    } else if (getEligibleCampaignsState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description:
          getEligibleCampaignsState.message ||
          'Failed to fetch eligible campaigns',
      });
      getEligibleCampaignsReset();
    }
  }, [getEligibleCampaignsState, getEligibleCampaignsReset]);

  // Handle create project from campaign response
  useEffect(() => {
    if (createProjectFromCampaignState.apiState === 'success') {
      const projectData =
        createProjectFromCampaignState.data?.data ||
        createProjectFromCampaignState.data;
      const newProjectId = projectData?.project?._id || projectData?._id;
      if (createProjectFolderId && newProjectId) {
        addItemToFolder(createProjectFolderId, newProjectId);
        // Navigate into the selected folder
        const selectedFolder = folders.find(
          f => f._id === createProjectFolderId
        );
        if (selectedFolder) {
          handleFolderClick(selectedFolder);
        }
      }
      notification.success({
        message: 'Success',
        description:
          createProjectFromCampaignState.message ||
          'Project created from campaign successfully',
      });
      setCreateProjectModal(false);
      form.resetFields();
      setIsSubmitting(false);
      setSelectedCampaignId(null);
      setCreateMode('scratch');
      setProjectBatchTag('');
      setCreateProjectFolderId(null);
      setCreateProjectDemographicFormat(null);
      refreshProjects();
      createProjectFromCampaignReset();

      // Navigate to the new project (only if no folder selected, otherwise we stay in folder view)
      if (!createProjectFolderId && newProjectId) {
        navigate(`/projects/details/${newProjectId}`);
      }
    } else if (createProjectFromCampaignState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description:
          createProjectFromCampaignState.message ||
          'Failed to create project from campaign',
      });
      setIsSubmitting(false);
      createProjectFromCampaignReset();
    }
  }, [
    createProjectFromCampaignState,
    createProjectFromCampaignReset,
    getProjects,
    navigate,
    createProjectFolderId,
  ]);

  // Handle URL-based pagination and filters
  useEffect(() => {
    const updatedFilters = getFiltersFromUrl();
    setFilters({ ...updatedFilters });
    setSearchValue(updatedFilters.search || '');
    if (currentFolderId) {
      getProjects({ ...updatedFilters, folderId: currentFolderId });
    } else {
      getProjects({ ...updatedFilters, excludeFoldered: true });
    }
  }, [window.location.search, currentFolderId]);

  // Handle projects response
  useEffect(() => {
    if (getProjectsState.apiState === 'success' && getProjectsState.data) {
      const projectsData = getProjectsState.data.data || getProjectsState.data;
      const projects = projectsData.projects || [];

      if (projects && projects.length > 0) {
        setTotalRecords(
          projectsData.pagination?.total || projectsData.total_count || 0
        );

        const updatedProjects = projects.map(item => ({
          key: item._id,
          id: item._id,
          _id: item._id,
          name: item.name || '-',
          description: item.description || '-',
          files_count: item.files_count || 0,
          status: item.status || 'draft',
          createdAt: formatDate(item.createdAt),
          sharedToMe: item.sharedToMe || false,
        }));

        setTableData(updatedProjects);
        setCardData(updatedProjects);
      } else {
        setTableData([]);
        setCardData([]);
        setTotalRecords(0);
      }
      getProjectsReset();
    } else if (getProjectsState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: getProjectsState.message || 'Failed to fetch projects',
      });
      getProjectsReset();
    }
  }, [getProjectsState, getProjectsReset]);

  // Handle create response
  useEffect(() => {
    if (createProjectState.apiState === 'success') {
      const projectData =
        createProjectState.data?.data || createProjectState.data;
      const newProjectId = projectData?.project?._id || projectData?._id;
      if (createProjectFolderId && newProjectId) {
        addItemToFolder(createProjectFolderId, newProjectId);
        // Navigate into the selected folder
        const selectedFolder = folders.find(
          f => f._id === createProjectFolderId
        );
        if (selectedFolder) {
          handleFolderClick(selectedFolder);
        }
      }
      notification.success({
        message: 'Success',
        description: 'Project created successfully',
      });
      setCreateProjectModal(false);
      form.resetFields();
      setIsSubmitting(false);
      setCreateProjectFolderId(null);
      setCreateProjectDemographicFormat(null);
      refreshProjects();
      createProjectReset();
    } else if (createProjectState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: createProjectState.message || 'Failed to create project',
      });
      setIsSubmitting(false);
      createProjectReset();
    }
  }, [createProjectState, createProjectReset, getProjects, createProjectFolderId]);

  // Handle delete response
  useEffect(() => {
    if (deleteProjectState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description:
          deleteProjectState.message || 'Project deleted successfully',
      });
      setDeleteModalVisible(false);
      setProjectToDelete(null);
      refreshProjects();
    } else if (deleteProjectState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: deleteProjectState.message || 'Failed to delete project',
      });
    }
    deleteProjectReset();
  }, [deleteProjectState, deleteProjectReset, getProjects]);

  // Handle update response
  useEffect(() => {
    if (updateProjectState.apiState === 'success') {
      notification.success({
        message: 'Success',
        description: 'Project updated successfully',
      });
      setEditModalVisible(false);
      setProjectToEdit(null);
      editForm.resetFields();
      refreshProjects();
      updateProjectReset();
    } else if (updateProjectState.apiState === 'error') {
      notification.error({
        message: 'Error',
        description: updateProjectState.message || 'Failed to update project',
      });
      updateProjectReset();
    }
  }, [updateProjectState, updateProjectReset, getProjects, editForm]);

  // Helper to re-fetch projects with current folder context
  const refreshProjects = () => {
    const updatedFilters = getFiltersFromUrl();
    if (currentFolderId) {
      getProjects({ ...updatedFilters, folderId: currentFolderId });
    } else {
      getProjects({ ...updatedFilters, excludeFoldered: true });
    }
  };

  // Folder hook: fetch on mount
  useEffect(() => {
    fetchFolders();
  }, []);

  // Folder hook: response handlers
  useEffect(() => { handleGetFoldersResponse(); }, [getFoldersState]);
  useEffect(() => { handleCreateFolderResponse(); }, [createFolderState]);
  useEffect(() => { handleRenameFolderResponse(); }, [renameFolderState]);
  useEffect(() => { handleDeleteFolderResponse(); }, [deleteFolderState]);
  useEffect(() => { handleAddItemToFolderResponse(); }, [addItemToFolderState]);
  useEffect(() => { handleRemoveItemFromFolderResponse(); }, [removeItemFromFolderState]);

  // Re-fetch projects when folder hook signals a refresh (after folder operations)
  useEffect(() => {
    if (refreshNeeded > 0) {
      refreshProjects();
    }
  }, [refreshNeeded]);

  // Build project detail URL with folder context for back navigation
  const getProjectDetailUrl = projectId => {
    if (currentFolderId) {
      return `/projects/details/${projectId}?fromFolderId=${currentFolderId}&fromFolderName=${encodeURIComponent(currentFolderName)}`;
    }
    return `/projects/details/${projectId}`;
  };

  const handleSearch = value => {
    const queryParams = new URLSearchParams(window.location.search);
    if (value) {
      queryParams.set('search', value);
    } else {
      queryParams.delete('search');
    }
    queryParams.set('page', '1');
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, '', newUrl);
    setFilters({ ...filters, search: value, page: 1 });
    setSearchValue(value);
  };

  const handleTableChange = (pagination, _, sorter) => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set('page', pagination.current || 1);
    queryParams.set('limit', pagination.pageSize || 12);

    if (sorter && Object.keys(sorter).length > 0) {
      queryParams.set('sortBy', sorter.field || 'createdAt');
      queryParams.set(
        'sortDirection',
        sorter.order === 'ascend' ? 'asc' : 'desc'
      );
    } else {
      queryParams.set('sortBy', 'createdAt');
      queryParams.set('sortDirection', 'desc');
    }

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, '', newUrl);
    setFilters({
      ...filters,
      sortBy: sorter?.field || 'createdAt',
      sortDirection: sorter?.order === 'ascend' ? 'asc' : 'desc',
      page: pagination.current || 1,
      limit: pagination.pageSize || 12,
    });
  };

  const handleCreateProject = () => {
    if ((isSuperAdmin || can('anonymous-demographic-switch')) && !createProjectDemographicFormat) {
      notification.warning({
        message: 'Demographic Format Required',
        description: 'Please select a demographic display format',
      });
      return;
    }
    form
      .validateFields()
      .then(values => {
        setIsSubmitting(true);
        createProject({
          name: values.name,
          description: values.description || null,
          ...(createProjectDemographicFormat && { demographic_format: createProjectDemographicFormat }),
        });
      })
      .catch(() => {
        // Form validation failed - errors are shown by the form
      });
  };

  const handleOpenCreateModal = () => {
    setCreateMode('scratch');
    setCreateProjectModal(true);
    // Auto-select current folder when inside a folder
    if (currentFolderId) {
      setCreateProjectFolderId(currentFolderId);
    }
    // Only fetch eligible campaigns if user has create-from-study permission
    if (can('create-from-study')) {
      getEligibleCampaigns();
    }
  };

  const handleCreateModeChange = mode => {
    setCreateMode(mode);
    // Clear campaign selection when switching to scratch mode
    if (mode === 'scratch') {
      setSelectedCampaignId(null);
      setProjectBatchTag('');
    }
  };

  const handleSubmitProject = () => {
    if ((isSuperAdmin || can('anonymous-demographic-switch')) && !createProjectDemographicFormat) {
      notification.warning({
        message: 'Demographic Format Required',
        description: 'Please select a demographic display format',
      });
      return;
    }
    if (createMode === 'campaign') {
      // Validate campaign selection
      if (!selectedCampaignId) {
        notification.warning({
          message: 'Study Required',
          description: 'Please select a study to import transcripts from',
        });
        return;
      }
      form
        .validateFields()
        .then(values => {
          setIsSubmitting(true);
          createProjectFromCampaign({
            campaignId: selectedCampaignId,
            name: values.name,
            description: values.description || null,
            batchTag: projectBatchTag.trim() || '',
            ...(createProjectDemographicFormat && { demographic_format: createProjectDemographicFormat }),
          });
        })
        .catch(() => {
          // Form validation failed - errors are shown by the form
        });
    } else {
      // Create from scratch
      handleCreateProject();
    }
  };

  const handleDelete = record => {
    setProjectToDelete(record);
    setDeleteModalVisible(true);
  };

  const confirmDelete = () => {
    if (projectToDelete) {
      deleteProject(projectToDelete.id);
    }
  };

  const handleEdit = record => {
    setProjectToEdit(record);
    editForm.setFieldsValue({
      name: record.name,
      description: record.description === '-' ? '' : record.description,
    });
    setEditModalVisible(true);
  };

  const handleUpdateProject = () => {
    editForm.validateFields().then(values => {
      updateProject(projectToEdit.id, {
        name: values.name,
        description: values.description || null,
      });
    });
  };

  // Render card menu following reference codebase pattern
  const renderCardMenu = record => {
    return (
      <Menu
        selectable={false}
        onClick={({ key, domEvent }) => {
          domEvent.stopPropagation();
          if (key === 'view') {
            navigate(getProjectDetailUrl(record.id));
          } else if (key === 'edit') {
            handleEdit(record);
          } else if (key === 'moveToFolder') {
            openMoveToFolderModal(record);
          } else if (key === 'removeFromFolder') {
            handleRemoveFromFolder(record);
          } else if (key === 'delete') {
            handleDelete(record);
          }
        }}
      >
        <Menu.Item key="view">View Details</Menu.Item>
        {can('edit') && <Menu.Item key="edit">Edit Details</Menu.Item>}
        <Menu.Item key="moveToFolder">Move to Folder</Menu.Item>
        {currentFolderId && (
          <Menu.Item key="removeFromFolder">Remove from Folder</Menu.Item>
        )}
        {can('delete') && (
          <>
            <Menu.Divider />
            <Menu.Item key="delete" disabled={record.status === 'deleting'}>
              Delete
            </Menu.Item>
          </>
        )}
      </Menu>
    );
  };

  const handleModalCancel = () => {
    setCreateProjectModal(false);
    form.resetFields();
    setSelectedCampaignId(null);
    setCreateMode('scratch');
    setProjectBatchTag('');
    setCreateProjectFolderId(null);
    setStudySearchValue('');
    setCreateProjectDemographicFormat(null);
  };

  const columns = [
    {
      title: 'Project Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <ProjectNameLink
          onClick={() => navigate(getProjectDetailUrl(record.id))}
        >
          {text}
        </ProjectNameLink>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: text => (
        <span>
          {text && text !== '-' ? (
            text.length > 100 ? (
              <>
                {text.substring(0, 100)}...
                <Tooltip
                  title={text}
                  placement="top"
                  overlayStyle={{ maxWidth: 350 }}
                >
                  <EllipsisOutlined
                    style={{
                      fontSize: 16,
                      color: '#3d2969',
                      cursor: 'pointer',
                      marginLeft: 4,
                      verticalAlign: 'middle',
                    }}
                    onClick={e => e.stopPropagation()}
                  />
                </Tooltip>
              </>
            ) : (
              text
            )
          ) : (
            '-'
          )}
        </span>
      ),
    },
    {
      title: 'Files Uploaded',
      dataIndex: 'files_count',
      key: 'files_count',
      render: count => <span>{count || 0}</span>,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: status => <ProjectStatusTag status={status} />,
    },
    {
      title: 'Created Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 180,
      sorter: true,
      render: (text, record) => (
        <span style={{ display: 'flex', alignItems: 'center' }}>
          {record.sharedToMe && (
            <>
              <Tooltip title="Shared with you">
                <UsergroupAddOutlined
                  style={{
                    fontSize: 14,
                    color: '#8b5cf6',
                    marginRight: 8,
                  }}
                />
              </Tooltip>
              <span style={{ marginRight: 8, color: '#d9d9d9' }}>|</span>
            </>
          )}
          {text}
        </span>
      ),
    },
    {
      title: 'Actions',
      key: 'actions',
      align: 'center',
      width: 120,
      render: (_, record) => (
        <ProjectTableActionWrapper>
          <ThemeFilterBtn
            shape="circle"
            size="medium"
            icon={<RightOutlined />}
            onClick={() => navigate(getProjectDetailUrl(record.id))}
          />
          <Dropdown
            trigger={['click']}
            placement="bottomRight"
            dropdownRender={() => renderCardMenu(record)}
          >
            <ThemeFilterBtn
              shape="circle"
              size="medium"
              icon={<EllipsisOutlined style={{ fontSize: 16 }} />}
              onClick={e => e.stopPropagation()}
            />
          </Dropdown>
        </ProjectTableActionWrapper>
      ),
    },
  ];

  return (
    <>
      <MobHeader />
      <ThemeMainWrapper>
          <Row gutter={[16, 16]} className="mb-6" align="middle">
            <Col
              xs={{ span: 8, order: 1 }}
              sm={{ span: 8, order: 1 }}
              md={{ span: 6, order: 1 }}
              lg={6}
              xl={8}
            >
              <GreetingText>Library</GreetingText>
            </Col>
            <Col
              xs={{ span: 24, order: 3 }}
              sm={{ span: 24, order: 3 }}
              md={{ span: 8, order: 1 }}
              lg={8}
              xl={8}
              className="text-center sm:text-center md:text-end lg:text-center xl:text-center"
            >
              <ThemeProjectTabWrapper>
                <div className="view-toggle">
                  <button
                    className={`toggle-btn ${activeView === "card" ? "active" : ""}`}
                    onClick={() => setActiveView("card")}
                  >
                    Card View
                  </button>
                  <button
                    className={`toggle-btn ${activeView === "table" ? "active" : ""}`}
                    onClick={() => setActiveView("table")}
                  >
                    Table View
                  </button>
                </div>
              </ThemeProjectTabWrapper>
            </Col>
            <Col
              xs={{ span: 16, order: 2 }}
              sm={{ span: 16, order: 2 }}
              md={{ span: 10, order: 1 }}
              lg={10}
              xl={8}
              className="text-end"
            >
              <Space gap={10}>
                {can('create') && (
                  isMobile ? (
                    <>
                      {!currentFolderId && (
                        <ThemeFilterBtn
                          className="background"
                          size="large"
                          shape="square"
                          icon={<img src="/images/folder-open-purple.svg" alt="Folder" style={{ width: 18, height: 18 }} />}
                          onClick={() => setCreateFolderModal(true)}
                        />
                      )}
                      <ThemeFilterBtn
                        className="background"
                        size="large"
                        shape="square"
                        icon={<img src="/images/plus-icon.svg" alt="New Project" />}
                        onClick={handleOpenCreateModal}
                      />
                    </>
                  ) : (
                    <>
                      {!currentFolderId && (
                        <NewFolderButton isMobile={false} onClick={() => setCreateFolderModal(true)} />
                      )}
                      <ThemeButton
                        size="large"
                        icon={<img src="/images/plus-icon.svg" alt="New Project" />}
                        onClick={handleOpenCreateModal}
                      >
                        New Project
                      </ThemeButton>
                    </>
                  )
                )}
              </Space>
            </Col>
          </Row>
          {currentFolderId && (
            <FolderBackNav currentFolderName={currentFolderName} onBack={handleBackToRoot} />
          )}
          <Row gutter={[16, 16]} className="mb-6" align="middle">
           <Col xs={24} sm={12} md={12} lg={10} xl={6} xxl={4}>
              <ThemeInput
                className="shadow"
                placeholder="Search libraries..."
                size="large"
                shape="square"
                prefix={<SearchOutlined />}
                value={searchValue}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchValue(value);
                  if (!value) {
                    handleSearch('');
                  }
                }}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />
            </Col>
          </Row>
          {activeView === "card" && (
            <>
              {/* Folder section (only at root, not inside a folder) */}
              {!currentFolderId && (
                <>
                  <FolderCardsSection
                    filteredFolders={filteredFolders}
                    foldersCollapsed={foldersCollapsed}
                    setFoldersCollapsed={setFoldersCollapsed}
                    onFolderClick={handleFolderClick}
                    onRenameFolderClick={openRenameFolderModal}
                    onDeleteFolderClick={openDeleteFolderModal}
                    enableDrag={true}
                    dragOverFolderId={dragOverFolderId}
                    onDragOver={handleFolderDragOver}
                    onDragEnter={handleFolderDragEnter}
                    onDragLeave={handleFolderDragLeave}
                    onDrop={handleFolderDrop}
                  />
                  {filteredFolders.length > 0 && cardData.length > 0 && (
                    <ItemsSectionLabel label="Projects" itemsCollapsed={projectsCollapsed} setItemsCollapsed={setProjectsCollapsed} />
                  )}
                </>
              )}
              {!(projectsCollapsed && filteredFolders.length > 0 && !currentFolderId) && (
              <>
                <Row gutter={[16, 16]} className="mb-6">
                  {getProjectsState.apiState === 'loading' ? (
                    Array.from({ length: 6 }).map((_, index) => (
                      <Col
                        span={24}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={8}
                        xxl={6}
                        xxxl={4}
                        key={`skeleton-${index}`}
                      >
                        <ThemeProjectCard loading={true} />
                      </Col>
                    ))
                  ) : cardData.length > 0 ? (
                    cardData.map(project => (
                      <Col
                        span={24}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={8}
                        xxl={6}
                        xxxl={4}
                        key={project.key}
                        draggable={
                          !currentFolderId && filteredFolders.length > 0
                        }
                        onDragStart={
                          !currentFolderId && filteredFolders.length > 0
                            ? e => handleDragStart(e, project)
                            : undefined
                        }
                        onDragEnd={
                          !currentFolderId && filteredFolders.length > 0
                            ? handleDragEnd
                            : undefined
                        }
                        style={
                          !currentFolderId && filteredFolders.length > 0
                            ? { cursor: 'grab' }
                            : undefined
                        }
                      >
                        <ThemeProjectCard
                          className={
                            getProjectStatusConfig(project.status).className
                          }
                          onClick={() =>
                            navigate(getProjectDetailUrl(project.id))
                          }
                          title={
                            <ProjectTag>
                              <Space size={0}>
                                {project.files_count || 0}
                                <ThemeDivider
                                  orientationMargin={0}
                                  type="vertical"
                                />
                                <img
                                  className="me-1"
                                  src="/images/files-uploaded-icon.svg"
                                  alt="Files"
                                />
                                Files Uploaded
                              </Space>
                            </ProjectTag>
                          }
                          extra={
                            <Space size={10}>
                              <ProjectStatusTag status={project.status} />
                              <Dropdown
                                trigger={['click']}
                                placement="bottomRight"
                                dropdownRender={() => renderCardMenu(project)}
                              >
                                <CardMenuIcon
                                  onClick={e => e.stopPropagation()}
                                >
                                  <img
                                    src="/images/menu-dots-vertical.svg"
                                    alt="Menu"
                                  />
                                </CardMenuIcon>
                              </Dropdown>
                            </Space>
                          }
                        >
                          <div
                            className="cursor-pointer title mb-1"
                            onClick={() =>
                              navigate(getProjectDetailUrl(project.id))
                            }
                          >
                            {project.name}
                          </div>
                          <Tooltip
                            title={
                              project.description &&
                              project.description !== '-' &&
                              project.description.length > 80
                                ? project.description
                                : null
                            }
                            placement="top"
                            overlayStyle={{ maxWidth: 350 }}
                          >
                            <div
                              className={`subTitle ${project.description && project.description !== '-' && project.description.length > 80 ? 'truncate-3-lines' : ''}`}
                              onClick={e => e.stopPropagation()}
                            >
                              {project.description &&
                              project.description !== '-'
                                ? project.description
                                : 'No description'}
                            </div>
                          </Tooltip>
                          <div className="actionWrapper">
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'nowrap',
                              }}
                            >
                              {project.sharedToMe && (
                                <>
                                  <Tooltip title="Shared with you">
                                    <UsergroupAddOutlined
                                      style={{
                                        fontSize: 14,
                                        color: '#8b5cf6',
                                        marginRight: 8,
                                      }}
                                    />
                                  </Tooltip>
                                  <span
                                    style={{ marginRight: 8, color: '#d9d9d9' }}
                                  >
                                    |
                                  </span>
                                </>
                              )}
                              <img
                                className="me-2"
                                src="/images/calendar-icon.svg"
                                alt="Calendar"
                              />
                              {project.createdAt}
                            </span>
                            <ThemeFilterBtn
                              onClick={() =>
                                navigate(getProjectDetailUrl(project.id))
                              }
                              className="noBackground btnBorder"
                              shape="circle"
                              size="medium"
                              icon={<RightOutlined />}
                            />
                          </div>
                        </ThemeProjectCard>
                      </Col>
                    ))
                  ) : (
                    <Col span={24} className="text-center">
                      <p>
                        {currentFolderId
                          ? 'No projects in this folder'
                          : 'No libraries found'}
                      </p>
                    </Col>
                  )}
                </Row>
                {totalRecords > 0 && (
                  <CardPaginationWrapper>
                    <Pagination
                      current={parseInt(filters.page) || 1}
                      pageSize={parseInt(filters.limit) || 12}
                      total={totalRecords}
                      showSizeChanger={true}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} of ${total} libraries`
                      }
                      onChange={(page, pageSize) =>
                        handleTableChange({ current: page, pageSize }, null, {})
                      }
                    />
                  </CardPaginationWrapper>
                )}
              </>
              )}
            </>
          )}
          {activeView === "table" && (
            <>
              {/* Folder navigation for table view */}
              {!currentFolderId && (
                <>
                  <FolderCardsSection
                    filteredFolders={filteredFolders}
                    foldersCollapsed={foldersCollapsed}
                    setFoldersCollapsed={setFoldersCollapsed}
                    onFolderClick={handleFolderClick}
                    onRenameFolderClick={openRenameFolderModal}
                    onDeleteFolderClick={openDeleteFolderModal}
                  />
                  {filteredFolders.length > 0 && (
                    <ItemsSectionLabel label="Projects" itemsCollapsed={projectsCollapsed} setItemsCollapsed={setProjectsCollapsed} />
                  )}
                </>
              )}
              {!(projectsCollapsed && filteredFolders.length > 0 && !currentFolderId) && (
              <ThemeTableCard>
                <Row gutter={[16, 16]}>
                  <Col xs={24}>
                    <ThemeTable
                      columns={columns}
                      dataSource={tableData}
                      pagination={{
                        current: parseInt(filters.page) || 1,
                        pageSize: parseInt(filters.limit) || 12,
                        total: totalRecords,
                        showSizeChanger: true,
                        showTotal: (total, range) =>
                          `${range[0]}-${range[1]} of ${total} libraries`,
                      }}
                      onChange={handleTableChange}
                      loading={getProjectsState.apiState === 'loading'}
                      scroll={{ x: 768 }}
                    />
                  </Col>
                </Row>
              </ThemeTableCard>
            )}
          </>
        )}
      </ThemeMainWrapper>

      {/* Create Project Modal */}
      <ThemeModal
        title="Create New Project"
        open={createProjectModal}
        onCancel={handleModalCancel}
        centered
        footer={null}
        width={600}
      >
        <Spin spinning={getEligibleCampaignsState.apiState === 'loading'}>
          {/* Create Mode Selection - Side by Side */}
          {can('create-from-study') && (
            <Row gutter={[10, 10]} style={{ marginBottom: 10, display: 'flex' }}>
              <Col xs={24} sm={12} style={{ display: 'flex' }}>
                <div
                  onClick={() => handleCreateModeChange('scratch')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '6px 10px',
                    border: `1px solid ${createMode === 'scratch' ? '#a768ce' : '#e8e8e8'}`,
                    borderRadius: 6,
                    cursor: 'pointer',
                    width: '100%',
                    background:
                      createMode === 'scratch'
                        ? 'rgba(167, 104, 206, 0.05)'
                        : 'white',
                  }}
                >
                  <Radio checked={createMode === 'scratch'} />
                  <div>
                    <div
                      style={{ fontSize: 13, fontWeight: 500, color: '#333' }}
                    >
                      Create from Scratch
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                      Upload your own files
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} style={{ display: 'flex' }}>
                <div
                  onClick={() => handleCreateModeChange('campaign')}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '6px 10px',
                    border: `1px solid ${createMode === 'campaign' ? '#a768ce' : '#e8e8e8'}`,
                    borderRadius: 6,
                    cursor: 'pointer',
                    width: '100%',
                    background:
                      createMode === 'campaign'
                        ? 'rgba(167, 104, 206, 0.05)'
                        : 'white',
                  }}
                >
                  <Radio checked={createMode === 'campaign'} />
                  <div>
                    <div
                      style={{ fontSize: 13, fontWeight: 500, color: '#333' }}
                    >
                      From Study Transcripts
                    </div>
                    <div style={{ fontSize: 10, color: '#666' }}>
                      Import from study
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <ThemeForm layout="vertical" form={form}>
            <Row>
              <Col xs={24}>
                <ThemeForm.Item
                  className="labelStyle1"
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: 'Please enter project name' },
                  ]}
                  style={{ marginBottom: 12 }}
                >
                  <ThemeInput placeholder="Enter project name" size="large" />
                </ThemeForm.Item>
              </Col>
              <Col xs={24}>
                <ThemeForm.Item
                  className="labelStyle1"
                  label="Description"
                  name="description"
                  style={{ marginBottom: 12 }}
                >
                  <ThemeInput.TextArea
                    placeholder="Enter a brief description (optional)"
                    size="large"
                    rows={2}
                  />
                </ThemeForm.Item>
              </Col>
            </Row>
          </ThemeForm>

          {/* Demographic Format Selection - only shown with permission */}
          {(isSuperAdmin || can('anonymous-demographic-switch')) && (
          <div style={{ marginTop: 0 }}>
            <div style={{ marginBottom: 6 }}>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 13, fontWeight: 500, color: '#0a1b39' }}>
                Demographic Display
              </span>
              <span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span>
              <Tooltip title="Controls how participant demographics (age, location) appear in AI responses for this project.">
                <InfoCircleOutlined style={{ color: '#999', fontSize: 13, marginLeft: 6, cursor: 'pointer' }} />
              </Tooltip>
            </div>
            <div style={{ fontSize: 11, color: '#666', marginBottom: 8 }}>
              Control how participant demographics appear in AI responses
            </div>
            <ProjectSettingsCard className="demographicCard" style={{ border: 'none' }} bodyStyle={{ padding: 0 }}>
              <Row gutter={[12, 12]} style={{ display: 'flex' }}>
                <Col xs={24} sm={12} style={{ display: 'flex' }}>
                  <div
                    className={`providerOption ${createProjectDemographicFormat === 'anonymized' ? 'active' : ''}`}
                    onClick={() => setCreateProjectDemographicFormat('anonymized')}
                    style={{ padding: '6px 10px', gap: 8, width: '100%' }}
                  >
                    <ThemeRadio checked={createProjectDemographicFormat === 'anonymized'} />
                    <div className="providerIcon" style={{ width: 18, height: 18, minWidth: 18 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" stroke="#6366f1" strokeWidth="2"/>
                        <path d="M12 6v6l4 2" stroke="#6366f1" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <div>
                      <div className="providerName" style={{ fontSize: 12 }}>General</div>
                      <div className="providerDesc" style={{ fontSize: 10 }}>Age ranges (18-24) & regions (Northeast)</div>
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={12} style={{ display: 'flex' }}>
                  <div
                    className={`providerOption ${createProjectDemographicFormat === 'detailed' ? 'active' : ''}`}
                    onClick={() => setCreateProjectDemographicFormat('detailed')}
                    style={{ padding: '6px 10px', gap: 8, width: '100%' }}
                  >
                    <ThemeRadio checked={createProjectDemographicFormat === 'detailed'} />
                    <div className="providerIcon" style={{ width: 18, height: 18, minWidth: 18 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2 17l10 5 10-5" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M2 12l10 5 10-5" stroke="#10b981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <div>
                      <div className="providerName" style={{ fontSize: 12 }}>Detailed</div>
                      <div className="providerDesc" style={{ fontSize: 10 }}>Exact ages (25) & locations (Oregon)</div>
                    </div>
                  </div>
                </Col>
              </Row>
            </ProjectSettingsCard>
          </div>
          )}

          {/* Folder Selection - Optional (always shown when inside a folder) */}
          <div style={{ marginTop: 10 }}>
            <FolderSelector
              folders={folders}
              currentFolderId={currentFolderId}
              currentFolderName={currentFolderName}
              createItemFolderId={createProjectFolderId}
              setCreateItemFolderId={setCreateProjectFolderId}
              XThemeSelect={XThemeSelect}
            />
          </div>

          {/* Study Selection - Only shown when campaign mode is selected */}
          {createMode === 'campaign' && (
            <div style={{ marginTop: 10 }}>
              <div style={{ marginBottom: 8 }}>
                <span style={{ fontWeight: 500, fontSize: 14 }}>
                  Select Study
                </span>
                {eligibleCampaigns.length > 0 && (
                  <span style={{ color: '#666', fontSize: 12, marginLeft: 8 }}>
                    ({eligibleCampaigns.length} available)
                  </span>
                )}
              </div>

              {getEligibleCampaignsState.apiState === 'loading' ? (
                <div className="text-center py-4">
                  <Spin />
                </div>
              ) : eligibleCampaigns.length === 0 ? (
                <div
                  style={{
                    padding: '16px',
                    textAlign: 'center',
                    color: '#666',
                    background: '#f9f9f9',
                    borderRadius: 8,
                  }}
                >
                  No studies with eligible transcripts found for your
                  account
              </div>
            ) : (
              <>
              {eligibleCampaigns.length > 5 && (
                <div style={{ marginBottom: 8 }}>
                  <ThemeInput
                    placeholder="Search studies..."
                    size="large"
                    prefix={<SearchOutlined />}
                    value={studySearchValue}
                    onChange={(e) => setStudySearchValue(e.target.value)}
                    allowClear
                  />
                </div>
              )}
              {(() => {
                const filtered = eligibleCampaigns.filter((c) =>
                  !studySearchValue || c.campaign_name?.toLowerCase().includes(studySearchValue.toLowerCase())
                );
                return filtered.length === 0 ? (
                  <div style={{ padding: '16px', textAlign: 'center', color: '#666', background: '#f9f9f9', borderRadius: 8 }}>
                    No studies match your search
                    </div>
                  ) : (
                    <ProjectListScrollable style={{ maxHeight: 200 }}>
                      <InsightEngineModalRadioGroup
                        onChange={e => setSelectedCampaignId(e.target.value)}
                        value={selectedCampaignId}
                      >
                        {filtered.map(campaign => (
                          <Radio key={campaign._id} value={campaign._id}>
                            <div className="radio-label-content">
                              <div className="radio-title">
                            {campaign.campaign_name}
                          </div>
                              <div className="radio-subtitle">
                                {campaign.transcript_count} Transcripts
                                {campaign.completed_at &&
                              ` | ${formatDate(campaign.completed_at)}`}
                              </div>
                            </div>
                            <Tag
                              color={campaign.status === 'completed' ? 'success' : campaign.status === 'in_progress' ? 'processing' : 'default'}
                              style={{ margin: '0 8px', fontSize: 11, borderRadius: 4 }}
                            >
                              {campaign.status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                            </Tag>
                            <div className="radio-icon">
                              <img src="/images/check-icon.svg" alt="Selected" />
                            </div>
                          </Radio>
                        ))}
                      </InsightEngineModalRadioGroup>
                    </ProjectListScrollable>
                );
              })()}
              </>
              )}

              {/* Tag input - shown when a study is selected */}
              {selectedCampaignId && (
                <div style={{ marginTop: 16 }}>
                  <div
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: 13,
                      fontWeight: 500,
                      color: '#0a1b39',
                      marginBottom: 8,
                    }}
                  >
                    Tag{' '}
                    <span
                      style={{ color: 'rgba(31,36,48,0.4)', fontWeight: 400 }}
                    >
                      (optional)
                    </span>
                  </div>
                  <ThemeInput
                    size="large"
                    placeholder="Enter a tag for this batch (e.g., Wave 1, Q1 Research)"
                    value={projectBatchTag}
                    onChange={e => setProjectBatchTag(e.target.value)}
                    disabled={isSubmitting}
                    style={{ width: '100%' }}
                  />
                </div>
              )}
            </div>
          )}

          {/* Footer Buttons */}
          <div className="text-end" style={{ paddingTop: 12 }}>
            <ThemeButton
              size="large"
              className="noBackground mr-3"
              onClick={handleModalCancel}
              disabled={isSubmitting}
            >
              Cancel
            </ThemeButton>
            <ThemeButton
              size="large"
              onClick={handleSubmitProject}
              loading={isSubmitting}
              disabled={
                isSubmitting ||
                ((isSuperAdmin || can('anonymous-demographic-switch')) && !createProjectDemographicFormat) ||
                (createMode === 'campaign' && !selectedCampaignId)
              }
            >
              Create Project
            </ThemeButton>
          </div>
        </Spin>
      </ThemeModal>

      {/* Delete Modal */}
      <ThemeModal
        title="Delete Project"
        open={deleteModalVisible}
        onOk={confirmDelete}
        onCancel={() => {
          setDeleteModalVisible(false);
          setProjectToDelete(null);
        }}
        confirmLoading={deleteProjectState.apiState === 'loading'}
        okText="Delete"
        cancelText="Cancel"
        centered
      >
        <p>
          {`Are you sure you want to delete project "${projectToDelete?.name}"?`}
        </p>
        <p>This action cannot be undone.</p>
        {projectToDelete?.files_count > 0 && (
          <p style={{ color: '#ff9800', marginTop: '8px' }}>
            <strong>{projectToDelete.files_count}</strong> file(s) will be
            deleted.
          </p>
        )}
      </ThemeModal>

      {/* Edit Details Modal */}
      <ThemeModal
        title="Edit Project Details"
        open={editModalVisible}
        onCancel={() => {
          setEditModalVisible(false);
          setProjectToEdit(null);
          editForm.resetFields();
        }}
        centered
        footer={null}
        width={500}
      >
        <ThemeForm layout="vertical" form={editForm}>
          <Row>
            <Col xs={24}>
              <ThemeForm.Item
                className="labelStyle1"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: 'Please enter project name' },
                ]}
              >
                <ThemeInput placeholder="Enter project name" size="large" />
              </ThemeForm.Item>
            </Col>
            <Col xs={24}>
              <ThemeForm.Item
                className="labelStyle1"
                label="Description"
                name="description"
              >
                <ThemeInput.TextArea
                  placeholder="Enter a brief description (optional)"
                  size="large"
                  rows={3}
                />
              </ThemeForm.Item>
            </Col>
          </Row>
        </ThemeForm>
        <div className="text-end mt-3">
          <ThemeButton
            size="large"
            className="noBackground mr-3"
            onClick={() => {
              setEditModalVisible(false);
              setProjectToEdit(null);
              editForm.resetFields();
            }}
            disabled={updateProjectState.apiState === 'loading'}
          >
            Cancel
          </ThemeButton>
          <ThemeButton
            size="large"
            onClick={handleUpdateProject}
            loading={updateProjectState.apiState === 'loading'}
          >
            Save Changes
          </ThemeButton>
        </div>
      </ThemeModal>

      {/* Folder Modals (Create, Rename, Delete, Move, Remove) */}
      <FolderModals
        createFolderModal={createFolderModal}
        setCreateFolderModal={setCreateFolderModal}
        folderForm={folderForm}
        handleCreateFolder={handleCreateFolder}
        createFolderState={createFolderState}
        renameFolderModal={renameFolderModal}
        setRenameFolderModal={setRenameFolderModal}
        folderToRename={folderToRename}
        renameFolderForm={renameFolderForm}
        handleRenameFolder={handleRenameFolder}
        renameFolderState={renameFolderState}
        deleteFolderModal={deleteFolderModal}
        setDeleteFolderModal={setDeleteFolderModal}
        folderToDelete={folderToDelete}
        handleDeleteFolder={handleDeleteFolder}
        deleteFolderState={deleteFolderState}
        removeFromFolderModal={removeFromFolderModal}
        setRemoveFromFolderModal={setRemoveFromFolderModal}
        itemToRemove={projectToRemove}
        confirmRemoveFromFolder={confirmRemoveFromFolder}
        removeItemFromFolderState={removeItemFromFolderState}
        moveToFolderModal={moveToFolderModal}
        setMoveToFolderModal={setMoveToFolderModal}
        itemToMove={folderHook.itemToMove}
        selectedFolderId={selectedFolderId}
        setSelectedFolderId={setSelectedFolderId}
        handleMoveToFolder={handleMoveToFolder}
        addItemToFolderState={addItemToFolderState}
        folders={folders}
        currentFolderId={currentFolderId}
        itemLabel="project"
      />
    </>
  );
};

const mapStateToProps = state => ({
  getProjectsState: state.project.getProjectsState,
  createProjectState: state.project.createProjectState,
  deleteProjectState: state.project.deleteProjectState,
  getEligibleCampaignsState: state.project.getEligibleCampaignsState,
  createProjectFromCampaignState: state.project.createProjectFromCampaignState,
  updateProjectState: state.project.updateProjectState,
});

const mapDispatchToProps = dispatch => ({
  getProjects: data => dispatch(getProjectsApi(data)),
  getProjectsReset: () => dispatch(getProjectsReset()),
  createProject: data => dispatch(createProjectApi(data)),
  createProjectReset: () => dispatch(createProjectReset()),
  deleteProject: id => dispatch(deleteProjectApi(id)),
  deleteProjectReset: () => dispatch(deleteProjectReset()),
  getEligibleCampaigns: () => dispatch(getEligibleCampaignsApi()),
  getEligibleCampaignsReset: () => dispatch(getEligibleCampaignsReset()),
  createProjectFromCampaign: data =>
    dispatch(createProjectFromCampaignApi(data)),
  createProjectFromCampaignReset: () =>
    dispatch(createProjectFromCampaignReset()),
  updateProject: (id, data) => dispatch(updateProjectApi(id, data)),
  updateProjectReset: () => dispatch(updateProjectReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Project);
